import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import { isLoggedInSelector, useAppSelector } from '@/store'

interface GSHashChangeHandlerProps {
  isOpen: boolean;
  gotoPage: any;
}

function GSHashChangeHandler(props: GSHashChangeHandlerProps) {

  const { isOpen, gotoPage } = props;
  const location = useLocation();
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;

    // const paths = [
    //   'order',
    //   'invoice',
    //   'quote',
    //   'shoppingLists',
    //   'purchased-products',
    //   'accountSettings',
    //   'login'
    // ];

    if (!hash || hash === '#' || hash === '') {
      return;
    }
    // const currentPath = hash.replace('#/', '').split('/')[0];

    if (sessionStorage.getItem('isLoggedIn') == 'false' && isLoggedIn) {
      navigate('login?loginFlag=3');
    }
  }, [location.hash, navigate, isLoggedIn])

  useEffect(() => {

    const onHashChange = () => {
      if (!isOpen) {
        gotoPage(location.pathname);
      }
    };

    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, [location]);

  return null;
}

export default GSHashChangeHandler;
